package com.essntl.features.message.data.supabase.message

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [MessageSupabaseDataSource::class])
internal class MessageSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<MessageDto> {
    override val tableName: String = "message"
}
